import { render, staticRenderFns } from "./course_create.vue?vue&type=template&id=229fa008&scoped=true"
import script from "./course_create.vue?vue&type=script&lang=js"
export * from "./course_create.vue?vue&type=script&lang=js"
import style1 from "../assets/styles/management.scss?vue&type=style&index=1&id=229fa008&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229fa008",
  null
  
)

export default component.exports